import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';


function RepresentantGestionAutocomplete({ onChange, required, variant, size, color, label, placeholder }) {

    const [representants, setRepresentants] = useState([]);

    const [selected, setSelected] = React.useState(null);

    const [loading, setLoading] = useState(false);
    

    // Fetch des representants

    useEffect(() => {
        const fetchData = async () => {

            setLoading(true);

            const result = await axios.get(`api/representants-gestion`);

            setRepresentants(result.data);
            setLoading(false);
        };

        fetchData();
    }, []);



    return (
        <Autocomplete

            options={representants}
            getOptionLabel={(option) => `${option.nom} (${option.code})`}
            loading={loading}

            value={selected}

            isOptionEqualToValue={(option, value) => {
                //console.log("option", option, "value", value, option && value && (option.code === value.code));
                return (option && value && (option.code === value.code));
                }
            }

            onChange={(event, newValue) => {

                //console.log("new value:", newValue);

                setSelected(newValue);
                onChange(newValue ? `${newValue.nom} (${newValue.code})` : ""); // TODO renvoyer la valeur 'object', et que l'appelant gère ce q'uil en fait.
            }}


            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    placeholder={placeholder}
                    required={required}
                    variant={variant}
                    size={size}
                    color={color}
                    fullWidth
                    InputLabelProps={{
                        shrink: true
                    }}
                />
            )}
        />
    );




}

RepresentantGestionAutocomplete.propTypes = {
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,

    variant: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,

    label: PropTypes.string,
    placeholder: PropTypes.string,
};

RepresentantGestionAutocomplete.defaultProps = {
    required: false,

    variant: "filled",
    size: "small",
    color: "secondary",

    label: "ATC",
    placeholder: "Rechercher un ATC",
}


export default RepresentantGestionAutocomplete;